<svg width="20" height="20" fill="none" version="1.1" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
 <g clip-path="url(#a)" clip-rule="evenodd" fill-rule="evenodd">
  <path d="M2.22222 20H17.7778C19.0051 20 20 19.0051 20 17.7778V2.22222C20 0.994923 19.0051 0 17.7778 0H2.22222C0.994923 0 0 0.994923 0 2.22222V17.7778C0 19.0051 0.994923 20 2.22222 20Z" fill="#7A7882"/>
  <path d="m17.222 17.222h-2.9679v-5.055c0-1.3859-0.5266-2.1604-1.6236-2.1604-1.1934 0-1.8168 0.806-1.8168 2.1604v5.055h-2.8602v-9.6296h2.8602v1.2971s0.86-1.5913 2.9034-1.5913c2.0426 0 3.5049 1.2473 3.5049 3.827v6.0969zm-12.681-10.891c-0.97425 0-1.7637-0.79565-1.7637-1.7769s0.78946-1.777 1.7637-1.777 1.7632 0.79566 1.7632 1.777-0.78899 1.7769-1.7632 1.7769zm-1.4769 10.891h2.9825v-9.6296h-2.9825v9.6296z" fill="#fff"/>
 </g>
 <defs>
  <clipPath id="a">
   <rect width="20" height="20" fill="#fff"/>
  </clipPath>
 </defs>
</svg>
